import React, { useEffect, useState } from 'react'
import { Container, Row, Col, Card, Button, Alert } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'

import logoBlack from '../assets/Logo-black-1.svg'
import vinnuskoliMyndCut from '../assets/vinnuskoliMyndCut.jpg'
import SelectLanguage from '../components/SelectLanguage'

import { status, StatusResponse } from '../api/account'

const Login = (): React.ReactElement => {
  const { t } = useTranslation('login')
  const [statusData, setStatusData] = useState<StatusResponse[]>()

  const loadStatus = async () => {
    try {
      const statusResponse = await status()

      setStatusData(statusResponse.data)
    } catch (e) {
      setStatusData(undefined)
    }
  }

  useEffect(() => {
    loadStatus()
  }, [])

  const island = () => {
    window.location.href = '/api/registration/island'
  }

  return (
    <Container className="pt-5">
      <img src={logoBlack} className="d-block mx-auto" alt="Vala Vinnuskóli" />

      <strong className="text-center mt-3 d-block" style={{ textTransform: 'uppercase' }}>
        Vinnuskóli
      </strong>

      {statusData && (
        <div className="mt-3">
          {statusData.map((e) => (
            <Alert variant={e.type}>{e.text}</Alert>
          ))}
        </div>
      )}

      <Row className="justify-content-center">
        <Col xl="10" lg="12" md="9">
          <Card className="o-hidden my-5">
            <Row>
              <Col
                lg="6"
                className="d-none d-lg-block"
                style={{
                  background: `url(${vinnuskoliMyndCut})`,
                  backgroundPosition: 'center',
                  backgroundSize: 'cover',
                }}
              ></Col>
              <Col lg="6">
                <SelectLanguage className="text-right px-2" />

                <div className="p-5">
                  <div className="text-center">
                    <h1 className="h4 text-gray-900 mb-4">{t('umsoknarvefur')}</h1>
                  </div>

                  <Button variant="primary" className="w-100" onClick={island}>
                    <span className="d-inline-block mt-1">{t('icekeylogin')}</span>
                  </Button>

                  <hr />

                  <div className="text-center">
                    <a className="small" href="https://www.vala.is">
                      {t('backtoFrontPage')}
                    </a>
                  </div>
                </div>
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>
    </Container>
  )
}

export default Login
